module.exports = __webpack_public_path__ + "static/img/5.0a8a716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/5.png
// module id = gPec
// module chunks = 0